angular.module("superSelect.components", []).component("superSelect", {
	templateUrl: "ng/components/superSelect/superSelect.view.html",
	bindings: {
		inputData: "<",
		choice: "=?",
		picks: "=?",
		maxPicks: "<",
		placeholder: "@",
		onChange: "&",
		propertyToShow: "@",
		propertyTranslate: "<",
		orientation: "@"
	},
	controllerAs: "SuperSelectController",
	controller: SuperSelectController
});

function SuperSelectController($scope) {

	/** not to loose *this reference **/
	var self = this;

	self.$onInit = function () {
		if (!self.inputData) return;
		//Init bindings here
		self.inputData = self.inputData || null;
		self.choice = self.choice || null;
		self.picks = self.picks || [];
		self.maxPicks = self.maxPicks || 0;
		self.placeholder = self.placeholder || "";
		self.onChange = self.onChange || function () {};
		self.orientation = self.orientation == 'top' ? true : false;

		//Internal copy of the supplied input


		//Choices
		$scope.choice = null;

	}

	function init() {
		if (self.inputData) {
			self.backup = self.inputData.slice();
			if (self.propertyToShow) {
				$scope.data = self.inputData
					.slice()
					.map(function (object) {
						return object[self.propertyToShow];
					});
			} else {
				$scope.data = self.inputData;
			}
		}
	}

	self.$onChanges = function (changes) {
		if (changes.inputData && changes.inputData.currentValue != []) {
			init();

		}
	}

	var somethingSelected = function (selectedItem) {

		var selected = self.inputData && self.inputData.filter(function (input) {
			return input[self.propertyToShow] == selectedItem
		}).pop();

		return !!selected;


	}

	var getItem = function (name) {
		return self.inputData.filter(function (input) {
			return input[self.propertyToShow] == name
		}).pop()
	}

	$scope.onSelectChange = function (selectedItem) {
		if (!selectedItem) return;

		if (selectedItem && self.propertyToShow &&
			somethingSelected(selectedItem)) {
			self.choice = selectedItem;
			$scope.choice = selectedItem;
			self.onChange({
				selectedItem: typeof selectedItem == "object" && getItem(selectedItem) || selectedItem
			});
			return;
		}

		//New input
		if ((selectedItem && 
				self.inputData.indexOf(selectedItem) === -1)) {
			console.log('new choice!');
			self.choice = selectedItem;
			$scope.choice = selectedItem;
			return []; //no dropdown visible
		}

		//Old input
		console.log('old choice!');
		self.choice = selectedItem;
		self.onChange();
	}

	$scope.clearSelection = function ($index) {

		console.log('dovrei eliminare: ', self.picks[$index]);

		clearChoice();
		$scope.data.push(self.picks[$index][self.propertyToShow]);

		self.picks = self.picks.filter(function (pick) {
			return pick != self.picks[$index];
		})

	}

	var clearChoice = function () {
		$scope.choice = undefined;
		self.choice = undefined;
	}

	var checkIsValuePresent = function (value) {
		return self.picks.includes(value);
	};

	$scope.getDropdownGoodTypes = function (search) {
		var dataCopy = $scope.data.slice();

		if (!search && !self.choice) {
			$scope.choice = null;
		}

		//New data supplied
		if (search && dataCopy.indexOf(search) === -1) {
			dataCopy.unshift(search);
			return dataCopy.propertyToShow;
		}

		//Just picking from choices, nothing is new
		if (!search && $scope.data) return $scope.data.slice();

	}

	$scope.addItem = function () {

		if (self.maxPicks && self.picks &&
			self.picks.length >= self.maxPicks) {
			console.log('max picks reached!');
			return;
		}

		//Check if the value is already present
		if (self.choice && checkIsValuePresent(self.choice)) {
			return;
		}

		/** if no choice, return */
		if (!self.choice) {
			/** check if a new option is supplied **/
			return;
		}

		/** 1.1 remove the item from the selectable ones (only $scope!) */
		/** 1. push the new item into the picks list */

		var objectPicked =
			self.backup
			.filter(function (backupValue) {
				return backupValue[self.propertyToShow] == self.choice;
			})
			.pop()

		self.picks.push(objectPicked);

		/** 2. if new, no need to clean the list from the value, return */
		var filtered = self.backup
			.filter(function (backupValue) {
				return backupValue[self.propertyToShow] == self.choice;
			})
			.map(function (value) {
				return value[self.propertyToShow];
			});

		if (filtered.indexOf(self.choice) === -1) {
			return;
		}

		$scope.data = $scope.data.filter(function (choice) {
			return choice != self.choice;
		});

		/** */
		$scope.data = $scope.data.slice();
		clearChoice();

	}


}
